import { defineComponent as a, useSlots as c, createBlock as p, openBlock as l, h as d } from "vue";
import { findChildrenVNodes as f } from "../util.js";
const m = /* @__PURE__ */ a({
  inheritAttrs: !1,
  __name: "Wrap",
  props: {
    disabled: { type: Boolean }
  },
  setup(r) {
    const s = r, e = c();
    function i() {
      const t = e.default({});
      if (!s.disabled && e.with) {
        const n = e.with({}), o = f(n);
        if (o.length > 1)
          throw new Error(`Wrap's "with" slot can only contain a single child node`);
        return d(o[0], t);
      }
      return t;
    }
    return (t, n) => (l(), p(i));
  }
});
export {
  m as default
};
